import { ReactNode } from 'react';
import './filterTabs.css';

type FilterTabsProps<T extends string> = {
    label: string;
    value: T;
    options: { value: T; label: ReactNode }[];
    onChange: (value: T) => void;
    role?: 'group' | 'tablist';
};

export const FilterTabs = <T extends string>({
    label,
    value,
    options,
    onChange,
    role = 'group',
}: FilterTabsProps<T>) => (
    <div className="mundu-filter-tabs" role={role} aria-label={label}>
        {options.map(option => (
            <button
                key={option.value}
                type="button"
                role={role === 'tablist' ? 'tab' : undefined}
                aria-selected={
                    role === 'tablist' ? value === option.value : undefined
                }
                aria-pressed={
                    role === 'group' ? value === option.value : undefined
                }
                className={
                    value === option.value
                        ? 'mundu-filter-tab-active'
                        : undefined
                }
                onClick={() => onChange(option.value)}
            >
                {option.label}
            </button>
        ))}
    </div>
);
